import React, { useContext, useState, useCallback } from "react";

import {
  Context,
  fetchActiveLearningMaterialLessons,
  fetchActiveLearningAllAnswers,
} from "../../../studentStore";
import useWaitApiCall from "../../../hooks/useWaitApiCall";
import Button from "../../../atoms/ActiveLearning/Button";
import Modal from "../../../atoms/ActiveLearning/Modal";
import Lesson1 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson1";
import Lesson2 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson2";
import Lesson3 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson3";
import Lesson4 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson4";
import Lesson5 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson5";
import Lesson6 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson6";
import Lesson7 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson7";
import Lesson8 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson8";
import Lesson9 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson9";
import Lesson10 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson10";
import Lesson11 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson11";
import Lesson12 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson12";
import Lesson13 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson13";
import Lesson14 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson14";
import Lesson15 from "../../../organisms/ActiveLearning/LessonsAnswerData/Lesson15";
import { ReactComponent as IconMyData } from "../../../assets/images/ActiveLearning/icon_mydata.svg";
import { ReactComponent as IconClose } from "../../../assets/images/ActiveLearning/icon_close.svg";

import styles from "./ActiveLearningLessonMyData.module.scss";

export const ActiveLearningLessonMyData = () => {
  const { state, dispatch } = useContext(Context);
  const [calling, peep] = useWaitApiCall(state);

  const [materialCode, setMaterialCode] = useState<"ECS001" | "ECS002">(
    "ECS001",
  );
  const [lessonNo, setLessonNo] = useState(1);
  const [isShowModal, setIsShowModal] = useState(false);

  const allStudents = state.classes.flatMap(classes => classes.students);

  const fetchActiveLearningMaterialLessonsFunc = useCallback(() => {
    dispatch(peep(fetchActiveLearningMaterialLessons()));
  }, [dispatch, peep]);

  const fetchActiveLearningAllAnswersFunc = useCallback(() => {
    dispatch(peep(fetchActiveLearningAllAnswers()));
  }, [dispatch, peep]);

  const lessonComponentsRound1 = [
    {
      no: 1,
      component: (
        <Lesson1
          materialCode={materialCode}
          lessonNo={1}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
          activeLearningThemes={state.active_learning_themes}
        />
      ),
    },
    {
      no: 2,
      component: (
        <Lesson2
          materialCode={materialCode}
          lessonNo={2}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
    {
      no: 3,
      component: (
        <Lesson3
          materialCode={materialCode}
          lessonNo={3}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
    {
      no: 4,
      component: (
        <Lesson4
          materialCode={materialCode}
          lessonNo={4}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
    {
      no: 5,
      component: (
        <Lesson5
          materialCode={materialCode}
          lessonNo={5}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
    {
      no: 6,
      component: (
        <Lesson6
          materialCode={materialCode}
          lessonNo={6}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
          students={allStudents}
        />
      ),
    },
    {
      no: 7,
      component: (
        <Lesson7
          materialCode={materialCode}
          lessonNo={7}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
    {
      no: 8,
      component: (
        <Lesson8
          materialCode={materialCode}
          lessonNo={8}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
    {
      no: 9,
      component: (
        <Lesson9
          materialCode={materialCode}
          lessonNo={9}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
    {
      no: 10,
      component: (
        <Lesson10
          materialCode={materialCode}
          lessonNo={10}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
          students={allStudents}
        />
      ),
    },
    {
      no: 11,
      component: (
        <Lesson11
          materialCode={materialCode}
          lessonNo={11}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
  ];

  const lessonComponentsRound2 = [
    {
      no: 1,
      component: (
        <Lesson1
          materialCode={materialCode}
          lessonNo={1}
          activeLearningAnswers={state.active_learning_all_answers}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningThemes={state.active_learning_themes}
        />
      ),
    },
    {
      no: 2,
      component: (
        <Lesson12
          materialCode={materialCode}
          lessonNo={2}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
    {
      no: 3,
      component: (
        <Lesson13
          materialCode={materialCode}
          lessonNo={3}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
    {
      no: 4,
      component: (
        <Lesson14
          materialCode={materialCode}
          lessonNo={4}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
    {
      no: 5,
      component: (
        <Lesson4
          materialCode={materialCode}
          lessonNo={5}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
    {
      no: 6,
      component: (
        <Lesson5
          materialCode={materialCode}
          lessonNo={6}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
    {
      no: 7,
      component: (
        <Lesson6
          materialCode={materialCode}
          lessonNo={7}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
          students={allStudents}
        />
      ),
    },
    {
      no: 8,
      component: (
        <Lesson7
          materialCode={materialCode}
          lessonNo={8}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
    {
      no: 9,
      component: (
        <Lesson8
          materialCode={materialCode}
          lessonNo={9}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
    {
      no: 10,
      component: (
        <Lesson9
          materialCode={materialCode}
          lessonNo={10}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
    {
      no: 11,
      component: (
        <Lesson10
          materialCode={materialCode}
          lessonNo={11}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
          students={allStudents}
        />
      ),
    },
    {
      no: 12,
      component: (
        <Lesson15
          materialCode={materialCode}
          lessonNo={12}
          activeLearningMaterialLessons={state.active_learning_material_lessons}
          activeLearningAnswers={state.active_learning_all_answers}
        />
      ),
    },
  ];

  const selectedRoundComponents =
    materialCode === "ECS001" ? lessonComponentsRound1 : lessonComponentsRound2;

  const selectedLessonComponent = selectedRoundComponents.find(
    lesson => lesson.no === lessonNo,
  );

  return (
    <>
      <button
        type="button"
        className={styles.myDataButton}
        onClick={() => {
          setIsShowModal(true);
          fetchActiveLearningMaterialLessonsFunc();
          fetchActiveLearningAllAnswersFunc();
        }}
        disabled={calling}
      >
        <IconMyData />
      </button>
      {isShowModal && (
        <Modal
          isTransparentBackground
          handleClose={() => setIsShowModal(false)}
        >
          <div className={styles.wrapper}>
            <IconClose
              className={styles.close}
              onClick={() => setIsShowModal(false)}
            />
            <div className={styles.inner}>
              <div className={styles.header}>
                <div className={styles.inner}>
                  <ul className={styles.roundList}>
                    <li className={styles.round}>
                      <Button
                        variant={
                          materialCode === "ECS001" ? "primary" : "secondary"
                        }
                        width={"240px"}
                        height={"40px"}
                        fontSize={"14px"}
                        handleClick={() => {
                          setMaterialCode("ECS001");
                          setLessonNo(1);
                        }}
                      >
                        1周目
                      </Button>
                    </li>
                    <li className={styles.round}>
                      <Button
                        variant={
                          materialCode === "ECS002" ? "primary" : "secondary"
                        }
                        width={"240px"}
                        height={"40px"}
                        fontSize={"14px"}
                        handleClick={() => {
                          setMaterialCode("ECS002");
                          setLessonNo(1);
                        }}
                      >
                        2周目
                      </Button>
                    </li>
                  </ul>
                  <ul className={styles.anchorList}>
                    {selectedRoundComponents.map(lesson => (
                      <li key={`lesson${lesson.no}`} className={styles.anchor}>
                        <Button
                          variant={
                            lesson.no === lessonNo ? "primary" : "secondary"
                          }
                          width={"103px"}
                          height={"34px"}
                          fontSize={"12px"}
                          handleClick={() => setLessonNo(lesson.no)}
                        >
                          {`Lesson${
                            lesson.no < 10 ? `0${lesson.no}` : lesson.no
                          }`}
                        </Button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              {selectedLessonComponent?.component}
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default ActiveLearningLessonMyData;
